import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const PersonaContext = createContext(null);

const STORAGE_KEY = "ma_persona_v1";

const DEFAULT_STATE = {
  persona: null, // "retire" | "relocate" | null
  status: null, // "exploring" | "researching" | "decided"
  country: null, // "Spain" | "Portugal" | "Italy" | "Open"
  checkinDone: false, // Spain Move Check-in shown once
  checkin: null,
  skipped: false, // visitor chose to explore on their own → neutral experience
};

function readStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_STATE;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_STATE, ...parsed };
  } catch {
    return DEFAULT_STATE;
  }
}

function writeStorage(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore */
  }
}

export function PersonaProvider({ children }) {
  const [state, setState] = useState(DEFAULT_STATE);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setState(readStorage());
    setReady(true);
  }, []);

  const updatePersona = useCallback((next) => {
    setState((prev) => {
      const merged = { ...prev, ...next };
      writeStorage(merged);
      return merged;
    });
  }, []);

  const reset = useCallback(() => {
    setState(DEFAULT_STATE);
    writeStorage(DEFAULT_STATE);
  }, []);

  const value = {
    ...state,
    ready,
    updatePersona,
    reset,
    isRetire: state.persona === "retire",
    isRelocate: state.persona === "relocate",
    hasPersona: !!state.persona,
  };

  return <PersonaContext.Provider value={value}>{children}</PersonaContext.Provider>;
}

export function usePersona() {
  const ctx = useContext(PersonaContext);
  if (!ctx) throw new Error("usePersona must be used inside <PersonaProvider>");
  return ctx;
}
